/* -------------------------------------------------------------------------------- *\
|                               stored
\* -------------------------------------------------------------------------------- */
function stored(): any
{
    return localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user') || '{}') : null;
}
/* -------------------------------------------------------------------------------- *\
|                               authHeader
\* -------------------------------------------------------------------------------- */
export function authHeader()
{
    const info = stored();
    if (info && info.username && info.accessToken)
        return { 'x-access-token': info.accessToken };
    return {};
}
/* -------------------------------------------------------------------------------- *\
|                               hasAuth
\* -------------------------------------------------------------------------------- */
export function hasAuth(): boolean
{
    const info = stored();
    return !!(info && info.username && info.accessToken);
}
/* -------------------------------------------------------------------------------- *\
|                               getUsername
\* -------------------------------------------------------------------------------- */
export function getUsername(): string
{
    const info = stored();
    return info && info.username && info.accessToken ? info.username : '';
}
/* -------------------------------------------------------------------------------- *\
|                               getToken
\* -------------------------------------------------------------------------------- */
export function getToken(): string
{
    const info = stored();
    if (info && info.username && info.accessToken)
        return info.accessToken;
    return '';
}
